var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Loading',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }